module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_ZAHN.9eb9cefb.png";